import React, { FC } from "react";
import { useSearchParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import Page from "../../components/Page";
import General from "./components/General";
import Invites from "./components/Invites";
import Organizations from "./components/Organizations";
import TabSection from "./components/TabSection";

const AccountSettings: FC = () => {
  const [searchParams] = useSearchParams();
  const [tabValue, setTabValue] = React.useState(
    searchParams.get("tab") || "organizations",
  );
  const handleChange = (
    _event: any,
    newValue: React.SetStateAction<string>,
  ) => {
    setTabValue(newValue);
  };

  return (
    <Page title="Account Settings">
      <Typography variant="h3" color="textPrimary">
        Account Settings
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          aria-labelledby={"accountSettingsTabs"}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          selectionFollowsFocus={true}
          value={tabValue}
        >
          <Tab
            label="General"
            aria-controls="tabpanel-general"
            id="tab-general"
            disableFocusRipple={true}
            disableRipple={true}
            value={"general"}
          />
          <Tab
            label="Organizations"
            aria-controls="tabpanel-organizations"
            id="tab-organizations"
            disableFocusRipple={true}
            disableRipple={true}
            value={"organizations"}
          />
          <Tab
            label="Invites"
            aria-controls="tabpanel-invites"
            id="tab-ivites"
            disableFocusRipple={true}
            disableRipple={true}
            value={"invites"}
          />
        </Tabs>
      </Box>
      <Box sx={{ mt: 3 }} component={tabValue === "general" ? Box : Paper}>
        {tabValue === "general" && <General />}
        <TabSection
          index="organizations"
          value={tabValue}
          title="Organizations"
        >
          <Organizations />
        </TabSection>
        <TabSection index="invites" value={tabValue} title="Invites">
          <Invites />
        </TabSection>
      </Box>
    </Page>
  );
};
export default AccountSettings;
